module.exports = __webpack_public_path__ + "img/pattern.ac5148ef.jpg";